import api from "@/assets/js/api"; // 引用統一 API 客戶端
import Swal from "sweetalert2";

const CART_ENDPOINT = "/Cart"; // 購物車 API 基礎路徑

export default {
  // 獲取購物車資料
  async fetchCartItems() {
    try {
      const response = await api.get(CART_ENDPOINT); // 更正為 GET 請求
      console.log("獲取購物車資料成功：", response.data);
      return response.data; // 返回購物車資料
    } catch (error) {
      console.error("獲取購物車資料失敗：", error.response || error.message);
      throw error;
    }
  },

  // 新增購物車項目
  async addToCart(
    room,
    packageName,
    totalPrice,
    packageId = null,
    checkinDate,
    checkoutDate
  ) {
    const cartPayload = {
      details: [
        {
          roomTypeId: room.id,
          packagesId: packageId ?? null,
          checkInDate: checkinDate,
          checkOutDate: checkoutDate,
          unitPrice: room.pricePerNight,
        },
      ],
    };

    try {
      // 使用統一的API調用，攔截器會自動處理Authorization header和401錯誤
      const response = await api.post(CART_ENDPOINT, cartPayload);

      Swal.fire({
        icon: "success",
        title: "已加入購物車",
        html: `✅ <b>${room.name}</b><br/>專案：${packageName}`,
        timer: 2000,
        showConfirmButton: false,
      });
      console.log("✅ 後端回傳：", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ 加入購物車失敗：", error.response || error.message);

      // 如果已經被API攔截器處理了401錯誤，就不需要重複處理
      if (error.response?.status === 401) {
        // 401錯誤已經在API攔截器中處理，這裡不需要額外處理
        return;
      }

      const isConflict = error.response?.status === 409;
      const serverMessage =
        error.response?.data?.message || error.response?.data?.Message;

      Swal.fire({
        icon: "error",
        title: "新增失敗",
        text: isConflict
          ? serverMessage || "房型已售完，請更換入住日期或房型"
          : error.message || "加入購物車時發生錯誤，請稍後再試！",
        confirmButtonText: "OK",
      });

      throw error;
    }
  },
  
  // 刪除購物車項目
  async deleteCartItem(cartItemId) {
    try {
      const response = await api.delete(`${CART_ENDPOINT}/${cartItemId}`);
      console.log("購物車刪除成功：", response.data);
      return response.data; // 返回刪除成功的回應
    } catch (error) {
      console.error("刪除購物車項目失敗：", error.response || error.message);
      throw error;
    }
  },
};
